import React, { useId } from 'react';
import { useTheme } from '@rbx/ui';

export const SvgIconTableOfContent = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.5 7.50016H5.83333V5.8335H17.5V7.50016ZM17.5 10.8335H5.83333V9.16683H17.5V10.8335ZM17.5 14.1668H5.83333V12.5002H17.5V14.1668ZM4.16667 14.1668H2.5V12.5002H4.16667V14.1668ZM4.16667 5.8335V7.50016H2.5V5.8335H4.16667ZM4.16667 10.8335H2.5V9.16683H4.16667V10.8335Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const SvgIconDefaultClass = () => {
  const { palette } = useTheme();

  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect
        x='6.66699'
        y='6.66675'
        width='6.66667'
        height='6.66667'
        rx='3.33333'
        fill={palette.content.muted}
      />
    </svg>
  );
};

export const SvgIconDefaultEnum = () => {
  const patternId = useId();
  const imageId = useId();

  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'>
      <rect x='0.210938' y='0.5' width='20' height='20' fill={`url(#${patternId})`} />
      <defs>
        <pattern id={patternId} patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use xlinkHref={`#${imageId}`} transform='scale(0.0208333)' />
        </pattern>
        <image
          id={imageId}
          width='48'
          height='48'
          preserveAspectRatio='none'
          xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABAElEQVRoBe2WMQ6CUAyGWzCuJlwFTyCTegZjPICTo7uTkyfQeAUTTdQbEI9C4kqU2jdAGMr2kBj/t8DrX17bjyavRFggAAIgAAL/TICbin8e4+nrLQlzcI3m6bnJr2u7WYBLvijoVCYnxJOyiGwfb5hppVq/1Ft+5lLwNlqkaytOYBk1+VHdLiLVXpNfqvat5F0afWFxMc1lFqAV3+vevVCqvWo71fK63vJ7HpK4mOYyW8h5ZofhmEWSIJTbYPa4mF/DCAIgAAIg8OsEGu8BzEL+fi1mIcIs5K+dcBIIgAAIgIBfApiF/PI0T8MshFnIbAwYQQAEQAAEQAAEQKB7Ah++rpkEcXku9QAAAABJRU5ErkJggg=='
        />
      </defs>
    </svg>
  );
};

export const SvgIconProperty = () => {
  return (
    <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.89453 9.38443V15.4702C4.89453 16.0225 5.34225 16.4702 5.89453 16.4702H11.9803C12.3781 16.4702 12.7597 16.3122 13.041 16.0309L15.4552 13.6167C15.7365 13.3354 15.8945 12.9538 15.8945 12.556V6.97021C15.8945 6.14179 15.223 5.47021 14.3945 5.47021H8.80874C8.41092 5.47021 8.02939 5.62825 7.74808 5.90955L5.33387 8.32377C5.05257 8.60507 4.89453 8.9866 4.89453 9.38443ZM8.80874 6.47021C8.67614 6.47021 8.54896 6.52289 8.45519 6.61666L6.60164 8.47021H11.8945C11.9841 8.47021 12.0709 8.48199 12.1536 8.50409L14.1874 6.47021H8.80874ZM14.8945 7.17732L12.8607 9.21119C12.8828 9.29381 12.8945 9.38064 12.8945 9.47021V14.7631L14.7481 12.9096C14.8419 12.8158 14.8945 12.6886 14.8945 12.556V7.17732Z'
        fill='#1AC8FF'
      />
    </svg>
  );
};

export const SvgIconMethod = () => {
  const clipPathId = useId();

  return (
    <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d='M14.7149 7.74818C14.4095 7.57548 14.0359 7.57548 13.7304 7.74818L9.98044 9.86867C9.89177 9.91881 9.81266 9.98134 9.7448 10.0534L14.2228 12.4053L18.7063 10.0596C18.6372 9.98493 18.5561 9.92025 18.4649 9.86867L14.7149 7.74818Z'
          fill='#E26CF4'
        />
        <path
          d='M18.9727 11.0488L14.7222 13.2726V17.9312L18.4649 15.8148C18.7787 15.6374 18.9727 15.3048 18.9727 14.9444V11.0488Z'
          fill='#E26CF4'
        />
        <path
          d='M9.47266 11.04L13.7222 13.2719V17.9307L9.98044 15.8148C9.66666 15.6374 9.47266 15.3048 9.47266 14.9444V11.04Z'
          fill='#E26CF4'
        />
        <path
          d='M8.72266 9.21985C8.85025 9.21985 8.9704 9.25171 9.07559 9.30792C8.6996 9.67497 8.47792 10.1812 8.47275 10.7198H6.22266C5.80844 10.7198 5.47266 10.3841 5.47266 9.96985C5.47266 9.55564 5.80844 9.21985 6.22266 9.21985H8.72266Z'
          fill='#E26CF4'
        />
        <path
          d='M8.22266 11.9796C8.31032 11.9796 8.39446 11.9947 8.47266 12.0223V13.4369C8.39446 13.4646 8.31032 13.4796 8.22266 13.4796H4.72266C4.30844 13.4796 3.97266 13.1438 3.97266 12.7296C3.97266 12.3154 4.30844 11.9796 4.72266 11.9796H8.22266Z'
          fill='#E26CF4'
        />
        <path
          d='M6.22266 14.7296H8.47266V14.9444C8.47266 15.4104 8.63476 15.853 8.91887 16.2037C8.85633 16.2206 8.79055 16.2296 8.72266 16.2296H6.22266C5.80844 16.2296 5.47266 15.8938 5.47266 15.4796C5.47266 15.0654 5.80844 14.7296 6.22266 14.7296Z'
          fill='#E26CF4'
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width='16.8421' height='24' fill='white' transform='translate(3.97266 0.970215)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SvgIconEvent = () => {
  const clipPathId = useId();

  return (
    <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d='M12.788 3.96973H7.81887C7.59378 3.96973 7.39643 4.12014 7.33676 4.33718L5.41219 11.3372C5.32468 11.6555 5.56419 11.9697 5.8943 11.9697H8.32037L7.95957 17.7677C7.94134 18.0607 8.3112 18.2028 8.49384 17.9731L15.0056 9.78085C15.266 9.45322 15.0327 8.96973 14.6142 8.96973H12.108L13.2712 4.5983C13.3556 4.28094 13.1164 3.96973 12.788 3.96973Z'
          fill='#F2BA2A'
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width='16' height='16' fill='white' transform='translate(2.39453 2.97021)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SvgIconWarning = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.00033 4.32699L13.0203 13.0003H2.98033L8.00033 4.32699ZM8.00033 1.66699L0.666992 14.3337H15.3337L8.00033 1.66699Z'
        fill='#F3BA2B'
      />
      <path d='M8.66699 11.0003H7.33366V12.3337H8.66699V11.0003Z' fill='#F3BA2B' />
      <path d='M8.66699 7.00033H7.33366V10.3337H8.66699V7.00033Z' fill='#F3BA2B' />
    </svg>
  );
};

export const SvgIconCopy = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 2H2.5C2.22386 2 2 2.22386 2 2.5V10C2 10.2761 2.22386 10.5 2.5 10.5C2.77614 10.5 3 10.7239 3 11C3 11.2761 2.77614 11.5 2.5 11.5C1.67157 11.5 1 10.8284 1 10V2.5C1 1.67157 1.67157 1 2.5 1H10C10.8284 1 11.5 1.67157 11.5 2.5C11.5 2.77614 11.2761 3 11 3C10.7239 3 10.5 2.77614 10.5 2.5C10.5 2.22386 10.2761 2 10 2ZM6 5.5H13.5C13.7761 5.5 14 5.72386 14 6V13.5C14 13.7761 13.7761 14 13.5 14H6C5.72386 14 5.5 13.7761 5.5 13.5V6C5.5 5.72386 5.72386 5.5 6 5.5ZM4.5 6C4.5 5.17157 5.17157 4.5 6 4.5H13.5C14.3284 4.5 15 5.17157 15 6V13.5C15 14.3284 14.3284 15 13.5 15H6C5.17157 15 4.5 14.3284 4.5 13.5V6Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const SvgIconExpand = () => {
  const clipPathId = useId();

  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d='M6.59726 13.4799C7.01148 13.4799 7.34726 13.8157 7.34726 14.2299C7.34726 14.6441 7.01148 14.9799 6.59726 14.9799L1.98242 14.9799C1.43014 14.9799 0.982423 14.5322 0.982423 13.9799L0.982422 9.36505C0.982423 8.95083 1.31821 8.61505 1.73242 8.61505C2.14664 8.61505 2.48242 8.95083 2.48242 9.36505L2.48242 12.4194L5.92215 8.97969C6.21504 8.6868 6.68992 8.6868 6.98281 8.97969C7.2757 9.27259 7.2757 9.74746 6.98281 10.0404L3.54327 13.4799L6.59726 13.4799Z'
          fill='currentColor'
        />
        <path
          d='M12.4213 2.48828L8.98174 5.92782C8.68884 6.22071 8.68884 6.69559 8.98174 6.98848C9.27463 7.28137 9.7495 7.28137 10.0424 6.98848L13.4813 3.54958L13.4813 6.60312C13.4813 7.01733 13.8171 7.35312 14.2313 7.35312C14.6455 7.35312 14.9813 7.01734 14.9813 6.60312L14.9813 1.98828C14.9813 1.436 14.5336 0.988281 13.9813 0.988281L9.36646 0.988282C8.95224 0.988282 8.61646 1.32407 8.61646 1.73828C8.61646 2.1525 8.95224 2.48828 9.36646 2.48828L12.4213 2.48828Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='matrix(4.37114e-08 1 1 -4.37114e-08 0 6.99382e-07)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SvgIconOpenSourceEdit = () => {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.00496 0C2.68437 0 0 2.70416 0 6.04958C0 8.72376 1.71997 10.9874 4.10603 11.7886C4.40435 11.8488 4.51362 11.6584 4.51362 11.4982C4.51362 11.358 4.50378 10.8773 4.50378 10.3764C2.83335 10.737 2.4855 9.65522 2.4855 9.65522C2.21705 8.9541 1.81929 8.77391 1.81929 8.77391C1.27255 8.40331 1.85911 8.40331 1.85911 8.40331C2.46558 8.44338 2.78381 9.02429 2.78381 9.02429C3.32059 9.94567 4.18555 9.68533 4.53353 9.52505C4.58319 9.13442 4.74237 8.864 4.91138 8.7138C3.57908 8.57355 2.17734 8.05276 2.17734 5.72902C2.17734 5.06797 2.4158 4.52714 2.79365 4.10652C2.73403 3.95632 2.5252 3.33522 2.85338 2.50393C2.85338 2.50393 3.36042 2.34365 4.50366 3.12491C4.99313 2.99249 5.4979 2.92512 6.00496 2.92455C6.512 2.92455 7.02886 2.99474 7.50614 3.12491C8.64951 2.34365 9.15655 2.50393 9.15655 2.50393C9.48473 3.33522 9.27577 3.95632 9.21616 4.10652C9.60396 4.52714 9.83259 5.06797 9.83259 5.72902C9.83259 8.05276 8.43085 8.56347 7.0886 8.7138C7.30739 8.90408 7.49619 9.26459 7.49619 9.83554C7.49619 10.6468 7.48635 11.2979 7.48635 11.4981C7.48635 11.6584 7.59575 11.8488 7.89395 11.7887C10.28 10.9873 12 8.72376 12 6.04958C12.0098 2.70416 9.3156 0 6.00496 0Z'
        fill='currentColor'
      />
    </svg>
  );
};
